import { type ObservableQuery, useApolloClient } from '@apollo/client';
import { useEffect, useRef } from 'react';
import { gql } from '@/__generated__';
import { useSubscription } from '@/apollo/use-subscription.ts';

const OnCustomCollectionsChanged = gql(`
  subscription OnCustomCollectionsChanged {
    onCustomCollectionsChanged
  }
`);

// Signup gifts land as separate jobs; one reload covers the burst.
const RELOAD_DEBOUNCE_MS = 500;

const LIST_POSTS_QUERIES = new Set([
  'GetCustomCollectionPosts',
  'GetCustomCollectionPostsMatchFilter',
]);

const isEmptyListPostsQuery = (query: ObservableQuery) =>
  LIST_POSTS_QUERIES.has(query.queryName ?? '') &&
  !query.getCurrentResult().data?.customCollectionPosts?.items?.length;

export const CustomCollectionsChangedSubscription = () => {
  const client = useApolloClient();
  const timer = useRef<number | undefined>(undefined);

  useEffect(() => () => window.clearTimeout(timer.current), []);

  useSubscription(OnCustomCollectionsChanged, {
    onData: () => {
      window.clearTimeout(timer.current);
      timer.current = window.setTimeout(() => {
        void client.refetchQueries({ include: ['streamDecksQuery'] });
        void client.refetchQueries({
          include: 'active',
          onQueryUpdated: isEmptyListPostsQuery,
        });
      }, RELOAD_DEBOUNCE_MS);
    },
  });

  return null;
};
